import { render } from "./Tabs.vue?vue&type=template&id=56b5aa90"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=56b5aa90&lang=css"
script.render = render

export default script